// extracted by mini-css-extract-plugin
module.exports = {"title-view":"styles__title-view__3GmfO","titleView":"styles__title-view__3GmfO","miscellany":"styles__miscellany__UuagB"};